import { useEffect, useRef } from "react";
import { servicePostLivechatTyping } from "../../../services/livechat";

const TYPING_EVERY_MS = 1000;
const STOP_AFTER_MS = 3000;

// "typing" at most once a second while keys are pressed; "stopped" after 3
// seconds of quiet, on send, or when the agent leaves the conversation
export const useLivechatTyping = (token, conversationId, isEnabled) => {
  const lastSentRef = useRef(0);
  const stopTimerRef = useRef(null);
  const isTypingRef = useRef(false);

  const stop = () => {
    clearTimeout(stopTimerRef.current);

    if (!isTypingRef.current) return;

    isTypingRef.current = false;
    lastSentRef.current = 0;
    servicePostLivechatTyping(token, conversationId, false);
  };

  const type = () => {
    if (!isEnabled || !conversationId) return;

    clearTimeout(stopTimerRef.current);
    stopTimerRef.current = setTimeout(stop, STOP_AFTER_MS);

    if (Date.now() - lastSentRef.current < TYPING_EVERY_MS) return;

    isTypingRef.current = true;
    lastSentRef.current = Date.now();
    servicePostLivechatTyping(token, conversationId, true);
  };

  // switching conversations ends the previous one's indicator
  useEffect(() => stop, [conversationId]); // eslint-disable-line react-hooks/exhaustive-deps

  return { type, stop };
};
